/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Time/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconCalendarMonth from 'DesignSystem/Svgs/TysiaIconCalendarMonth/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Time({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/Content/Content/Content/Events/Content/Compact/Past/Content/Content/AppointmentCell/Time"
  
}) {
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let eventAppointmentBookingLocalStartDateValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.local_start_date',
})
let eventAppointmentBookingLocalStartTimeValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.local_start_time',
})
let aggregateData = fromHelpers.formatDateTime(eventAppointmentBookingLocalStartDateValueData, eventAppointmentBookingLocalStartTimeValueData)
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Time.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconCalendarMonth
  viewPath={`${viewPath}/TysiaIconCalendarMonth`}
 fill={dtColorsNeutral600}
 height={dtSpaceS}
 width={dtSpaceS}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="event.appointment.booking.local_start_date"
 data="event.appointment.booking.local_start_time"
 aggregate="helpers.js formatDateTime"
 text={aggregateData}
 color={dtColorsNeutral700}
 marginLeft={dtSpaceXxs}
/>
</div>
{children}
</React.Fragment>)
}